/* eslint-disable max-lines */
import { campaign } from 'api';
import { lsSetOfferGuid, lsGetOfferGuid, lsRemoveOfferGuid } from 'helpers/store';
import { trimAndUppercase, isBase64Encode, base64ToUtf8 } from 'helpers/string';
import {
  OFFER_SET_CURRENT_STEP,
  OFFER_UPDATE,
  OFFER_CHECK_GUID,
  OFFER_STATE_PROCESS,
  OFFER_OPERATION_BY_GUID,
  OFFER_CAMPAIGN_BY_ID,
  OFFER_CAMPAIGN_BY_ORDER_ID,
  OFFER_CAMPAIGN_BY_GUID,
  OFFER_UPDATE_FROM_GUID,
  OFFER_UPDATE_OPERATION,
  OFFER_CREATE_OPERATION,
  OFFER_CREATE_OPERATION_DATA,
  OFFER_RESULT_INSTANTOR,
  OFFER_DOCUMENTS_REQUIRED_BY_GUID,
  OFFER_UPDATE_DOCUMENTS_REQUIRED,
  OFFER_UPDATE_SIGN,
  OFFER_CHECK_ELECTRONIC_SIGNATURE,
  OFFER_ELECTRONIC_SIGNATURE,
  OFFER_PATCH_OPERATION,
  OFFER_UPLOAD_STUDY_DOCUMENTATION,
  OFFER_REGISTER_SIGNATURE,
  PRECONTRACT_BY_GUID,
  PRECONTRACT_UPDATE,
  OFFER_COMPLETED_KO,
  OFFER_UPDATE_COMPLETED_KO,
  OFFER_LEGAL_CONDITIONS,
  OFFER_LEGAL_CONDITIONS_BY_GUID,
  OFFER_COMPONENTS_BY_PARTNER_ID,
  OFFER_OPERATION_STEPBACK,
  STRIPE_REPAYMENT,
  STRIPE_PAYMENT_CHECK
} from 'store/actions/offer';
import {
  UPDATE_CONTACT_PROSPECT,
  UPDATE_OPERATION_DATA,
  PROSPECT_TRANSFORM_PATCH_OPERATION,
  SET_OPERATION_PROPERTY
} from 'store/actions/operation';
import { UI_UPDATE_FROM_OFFER } from 'store/actions/ui';
import { OFFER_STATUS, OFFER_COOKIE_TO_PAGE, STRIPE_STATUS } from 'store/enums';
import { dateToISO } from 'helpers/date';

export default {
  [OFFER_CHECK_GUID]: ({ commit, dispatch }, guid) =>
    new Promise((resolve, reject) => {
      campaign.validateCookie(guid).then(
        resp => {
          dispatch(OFFER_UPDATE_FROM_GUID, { data: resp.data, guid })
            .then(res => resolve(res))
            .catch(() => reject());
        },
        err => {
          const { status } = err.response;
          commit('ERROR_OCCURRED', err, { root: true });
          if (status === 409) resolve();
          else reject();
        }
      );
    }),

  [OFFER_STATE_PROCESS]: ({ commit, dispatch, getters, rootGetters }, consents) =>
    new Promise((resolve, reject) => {
      const guid = getters.getOfferField('guidURL');
      campaign
        .getStateProcess({
          id: guid,
          ...rootGetters['operation/getDataForOfferStateProcess']
        })
        .then(
          resp => {
            const { data } = resp;
            if (consents && OFFER_STATUS.OK === data.idStatus) {
              campaign.appliedConsents(guid, consents).then(
                () => {
                  dispatch(OFFER_UPDATE_FROM_GUID, { data })
                    .then(res => resolve(res))
                    .catch(() => reject());
                },
                err => {
                  commit('ERROR_OCCURRED', err, { root: true });
                  reject();
                }
              );
            } else {
              dispatch(OFFER_UPDATE_FROM_GUID, { data, guid })
                .then(res => resolve(res))
                .catch(() => reject());
            }
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_OPERATION_BY_GUID]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      const { guid } = params || {};
      campaign.operationByGUID(guid || lsGetOfferGuid()).then(
        resp => {
          commit(`operation/${UPDATE_OPERATION_DATA}`, resp.data, {
            root: true
          });
          commit(OFFER_UPDATE_OPERATION, resp.data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_CAMPAIGN_BY_ID]: ({ commit, getters }, query) =>
    new Promise((resolve, reject) => {
      campaign
        .campaignFront({
          id: getters.getOfferField('idOffer'),
          partnerid: getters.getOfferField('partnerId'),
          idc: getters.getOfferField('idc')
        })
        .then(
          resp => {
            const data = resp.data;
            const { theme, campaignDetail, partnerFooter } = data;
            commit(OFFER_UPDATE, data);
            commit(
              `ui/${UI_UPDATE_FROM_OFFER}`,
              {
                theme,
                logoFrontLeft: campaignDetail.logoFrontLeft,
                logoFrontRight: campaignDetail.logoFrontRight,
                footerLogos: partnerFooter.logos,
                footerPubli: partnerFooter.logoPubli,
                disclaimer: partnerFooter.disclaimer
              },
              { root: true }
            );
            // Updated Operation from query string
            if (query) {
              const { docNum, polNum } = query;
              // Update documentId from query string
              if (docNum) {
                commit(
                  `operation/${SET_OPERATION_PROPERTY}`,
                  {
                    field: 'prospect.contact.0.documentId',
                    value: base64ToUtf8(docNum)
                  },
                  { root: true }
                );
              }
              // Update policy number from query string
              if (polNum) {
                commit(
                  `operation/${SET_OPERATION_PROPERTY}`,
                  {
                    field: 'prospect.contact.0.polNum',
                    value: isBase64Encode(polNum) ? base64ToUtf8(polNum) : polNum
                  },
                  { root: true }
                );
              }
            }
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_CAMPAIGN_BY_ORDER_ID]: ({ commit, dispatch, getters }) =>
    new Promise((resolve, reject) => {
      const cookieGuid = lsGetOfferGuid();
      const orderId = getters.getOfferField('orderId');
      campaign
        .campaignFrontByOrderId({
          id: getters.getOfferField('idOffer'),
          partnerId: getters.getOfferField('partnerId'),
          orderId,
          accessToken: getters.getOfferField('accessToken')
        })
        .then(
          resp => {
            const data = resp.data;
            const { theme, campaignDetail, partnerFooter, contact } = data;
            commit(OFFER_UPDATE, data);
            commit(
              `ui/${UI_UPDATE_FROM_OFFER}`,
              {
                theme,
                logoFrontLeft: campaignDetail.logoFrontLeft,
                logoFrontRight: campaignDetail.logoFrontRight,
                footerLogos: partnerFooter.logos,
                footerPubli: partnerFooter.logoPubli,
                disclaimer: partnerFooter.disclaimer
              },
              { root: true }
            );
            if (contact) {
              commit(
                `operation/${UPDATE_CONTACT_PROSPECT}`,
                {
                  contact,
                  pos: 0
                },
                {
                  root: true
                }
              );
            }
            // Verificar aquí siempe la cookie y el estado del paso con el orderId
            dispatch(OFFER_CHECK_GUID, orderId)
              .then(respCheckGuid => {
                if (respCheckGuid === 'identify-amazon') {
                  resolve();
                } else if (cookieGuid && orderId && cookieGuid === orderId) {
                  resolve(respCheckGuid);
                } else {
                  // Redirect to Identify page
                  lsRemoveOfferGuid();
                  window.location.href = `/${orderId}`;
                }
              })
              .catch(() => reject());
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_CAMPAIGN_BY_GUID]: ({ commit }, guid) =>
    new Promise((resolve, reject) => {
      campaign.campaignFrontByGuid(guid).then(
        resp => {
          const data = resp.data;
          const { theme, campaignDetail, partnerFooter } = data;
          commit(OFFER_UPDATE, data);
          commit(
            `ui/${UI_UPDATE_FROM_OFFER}`,
            {
              theme,
              logoFrontLeft: campaignDetail.logoFrontLeft,
              logoFrontRight: campaignDetail.logoFrontRight,
              footerLogos: partnerFooter.logos,
              footerPubli: partnerFooter.logoPubli,
              disclaimer: partnerFooter.disclaimer
            },
            { root: true }
          );
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_CREATE_OPERATION]: ({ rootState, commit, dispatch, getters }, { partnerId, consents }) =>
    new Promise((resolve, reject) => {
      commit(OFFER_CREATE_OPERATION_DATA, {
        ...JSON.parse(JSON.stringify(rootState.operation)),
        partnerId
      });
      campaign.createOperation(partnerId, getters.getOfferField('createOperationData')).then(
        resp => {
          const { data } = resp;
          data.idStatus = data.code;
          data.desStatus = data.step;
          data.guid = data.currentGuid;
          if (consents) {
            campaign.appliedConsents(data.currentGuid, consents).then(
              () => {
                dispatch(OFFER_UPDATE_FROM_GUID, { data })
                  .then(res => resolve(res))
                  .catch(() => reject());
              },
              err => {
                commit('ERROR_OCCURRED', err, { root: true });
                reject();
              }
            );
          } else {
            dispatch(OFFER_UPDATE_FROM_GUID, { data })
              .then(res => resolve(res))
              .catch(() => reject());
          }
        },
        err => {
          const { status, data } = err.response || err;
          if (status === 409 && data.errorCode) {
            data.idStatus = data.errorCode;
            data.desStatus = data.messageShow;
          }
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_RESULT_INSTANTOR]: ({ commit, getters }, idRequestInstanstor) =>
    new Promise((resolve, reject) => {
      commit(OFFER_RESULT_INSTANTOR, idRequestInstanstor);
      campaign
        .riskAnalysis({
          guid: lsGetOfferGuid(),
          idRequestInstantor: getters.getOfferField('idRequestInstanstor')
        })
        .then(
          resp => {
            const { idStatus, desStatus, url } = resp.data;
            if (OFFER_STATUS.OK === idStatus) {
              const cookieToPage = OFFER_COOKIE_TO_PAGE[desStatus.toString().toLowerCase()];
              commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
              resolve({ routerName: cookieToPage.routerName, url });
            } else {
              commit(
                'ERROR_OCCURRED',
                { status: 409, data: { idStatus, desStatus } },
                { root: true }
              );
              reject();
            }
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_DOCUMENTS_REQUIRED_BY_GUID]: ({ commit }, step) =>
    new Promise((resolve, reject) => {
      campaign
        .documentsRequiredByGuid({
          guid: lsGetOfferGuid(),
          step
        })
        .then(
          resp => {
            commit(OFFER_UPDATE_DOCUMENTS_REQUIRED, resp.data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_UPDATE_SIGN]: ({ rootState, commit, getters }) =>
    new Promise((resolve, reject) => {
      const {
        bankAccount,
        billingAgreementId,
        tokenStripe,
        electronicId,
        delivery,
        ...partialObject
      } = rootState.operation.signRequest;
      const commitData = {
        province: delivery.provinceCode,
        ...partialObject
      };
      if (getters.getOfferField('offer.campaignType') !== 'USADO') {
        commitData.requestedDeliveryDate = dateToISO(delivery.requestedDeliveryDate);
        commitData.requestedDeliveryPopulation = delivery.requestedDeliveryPopulation;
      }
      // Check fields content value
      if (bankAccount) commitData.bankAccount = trimAndUppercase(bankAccount);
      if (billingAgreementId) commitData.billingAgreementId = billingAgreementId;
      if (tokenStripe) commitData.tokenStripe = tokenStripe;
      if (electronicId) commitData.electronicId = electronicId;
      commit(OFFER_UPDATE_SIGN, {
        guid: getters.getOfferField('orderId') || lsGetOfferGuid(),
        data: commitData
      });
      campaign.updateSign(getters.getOfferField('singRequestData')).then(
        resp => {
          const data = resp.data;
          if (OFFER_STATUS.OK === data.idStatus) {
            const { url, message, stripe } = data;
            commit(OFFER_REGISTER_SIGNATURE, { url, message });
            if (stripe && stripe.status === STRIPE_STATUS.REQUERES_ACTION && stripe.url) {
              window.location.href = stripe.url;
            } else {
              const cookieToPage = OFFER_COOKIE_TO_PAGE[data.desStatus.toString().toLowerCase()];
              commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
              resolve({
                routerName: cookieToPage.routerName,
                url: data.url,
                additionalText: data.additionalText
              });
            }
          } else {
            reject();
          }
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_CHECK_ELECTRONIC_SIGNATURE]: ({ rootState, commit, dispatch }) =>
    new Promise((resolve, reject) => {
      commit(`operation/${PROSPECT_TRANSFORM_PATCH_OPERATION}`, null, {
        root: true
      });
      if (rootState.operation.patchOperationToSend.length > 0) {
        dispatch(OFFER_PATCH_OPERATION)
          .then(() => {
            dispatch(OFFER_ELECTRONIC_SIGNATURE)
              .then(res => resolve(res))
              .catch(() => reject());
          })
          .catch(err => reject(err));
      } else {
        dispatch(OFFER_ELECTRONIC_SIGNATURE)
          .then(res => resolve(res))
          .catch(() => reject());
      }
    }),

  [OFFER_ELECTRONIC_SIGNATURE]: ({ commit, getters }) =>
    new Promise((resolve, reject) => {
      campaign
        .electronicSignature({
          Id: getters.getOfferField('idOperation'),
          gvGuid: lsGetOfferGuid()
        })
        .then(
          resp => {
            const { idStatus, desStatus, url } = resp.data;
            if (OFFER_STATUS.OK === idStatus) {
              const cookieToPage = OFFER_COOKIE_TO_PAGE[desStatus.toString().toLowerCase()];
              commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
              resolve({ routerName: cookieToPage.routerName, url });
            } else {
              commit(
                'ERROR_OCCURRED',
                { status: 409, data: { idStatus, desStatus } },
                { root: true }
              );
              reject();
            }
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_PATCH_OPERATION]: ({ rootState, commit }) =>
    new Promise((resolve, reject) => {
      campaign
        .patchOperation({
          guid: lsGetOfferGuid(),
          operations: rootState.operation.patchOperationToSend
        })
        .then(
          resp => {
            if (OFFER_STATUS.OK === resp.data.idStatus) resolve();
            else reject();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_UPLOAD_STUDY_DOCUMENTATION]: ({ commit }, consents) =>
    new Promise((resolve, reject) => {
      const guid = lsGetOfferGuid();
      campaign.uploadStudyDocumentation(guid).then(
        resp => {
          const { idStatus, desStatus, url } = resp.data;
          if (OFFER_STATUS.OK === idStatus) {
            const cookieToPage = OFFER_COOKIE_TO_PAGE[desStatus.toString().toLowerCase()];
            commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
            if (consents) {
              campaign.appliedConsents(guid, consents).then(
                () => resolve({ routerName: cookieToPage.routerName, url }),
                err => {
                  commit('ERROR_OCCURRED', err, { root: true });
                  reject();
                }
              );
            } else resolve({ routerName: cookieToPage.routerName, url });
          } else reject();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_REGISTER_SIGNATURE]: ({ commit }, params) =>
    new Promise((resolve, reject) => {
      campaign.registerSignature(params).then(
        resp => {
          const data = resp.data;
          if (OFFER_STATUS.OK === data.idStatus) {
            const { stripe } = data;
            if (stripe && stripe.status === STRIPE_STATUS.REQUERES_ACTION && stripe.url) {
              window.location.href = stripe.url;
            } else {
              resolve(data);
            }
          } else {
            reject();
          }
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [STRIPE_REPAYMENT]: ({ commit, getters }, params) =>
    new Promise((resolve, reject) => {
      campaign
        .stripeRepayment({
          ...params,
          ...{ guid: getters.getOfferField('guidURL') || lsGetOfferGuid() }
        })
        .then(
          resp => {
            const data = resp.data;
            if (OFFER_STATUS.OK === data.idStatus) {
              // Si se van a enviar estos campos url, message
              const { desStatus, message, stripe } = data;
              const { step, routerName } =
                OFFER_COOKIE_TO_PAGE[desStatus.toString().toLowerCase()] || {};
              commit(OFFER_SET_CURRENT_STEP, step);
              commit(OFFER_REGISTER_SIGNATURE, { message });
              // Check stripe field
              if (stripe && stripe.status === STRIPE_STATUS.REQUERES_ACTION && stripe.url) {
                window.location.href = stripe.url;
              } else {
                resolve({ routerName });
              }
            } else {
              reject();
            }
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [STRIPE_PAYMENT_CHECK]: ({ commit }, { params, query }) =>
    new Promise((resolve, reject) => {
      campaign
        .stripePaymentCheck({
          operationId: params.guid,
          paymentIntentId: query.payment_intent,
          paymentIntentClientSecret: query.payment_intent_client_secret,
          sourceType: query.source_type
        })
        .then(
          resp => {
            const data = resp.data;
            if (OFFER_STATUS.OK === data.idStatus) {
              const { desStatus } = data;
              const { step, routerName } =
                OFFER_COOKIE_TO_PAGE[desStatus.toString().toLowerCase()] || {};
              lsSetOfferGuid(params.guid);
              commit(OFFER_SET_CURRENT_STEP, step);
              resolve({ routerName });
            } else {
              reject();
            }
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [PRECONTRACT_BY_GUID]: ({ commit }, guid) =>
    new Promise((resolve, reject) => {
      campaign.precontractByGUID(guid || lsGetOfferGuid()).then(
        resp => {
          const { data } = resp;
          if (data) {
            commit(PRECONTRACT_UPDATE, data);
            resolve();
          } else reject();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_LEGAL_CONDITIONS]: ({ commit, getters }, step) =>
    new Promise((resolve, reject) => {
      campaign
        .legalConditions({
          idOffer: getters.getOfferField('idOffer'),
          step
        })
        .then(
          resp => {
            commit(OFFER_LEGAL_CONDITIONS, resp.data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_LEGAL_CONDITIONS_BY_GUID]: ({ commit, getters }, step) =>
    new Promise((resolve, reject) => {
      campaign
        .legalConditionsByGuid({
          guid: getters.getOfferField('guidURL'),
          step
        })
        .then(
          resp => {
            commit(OFFER_LEGAL_CONDITIONS, resp.data);
            resolve();
          },
          err => {
            commit('ERROR_OCCURRED', err, { root: true });
            reject();
          }
        );
    }),

  [OFFER_COMPONENTS_BY_PARTNER_ID]: ({ commit, getters }, { id, partnerId }) =>
    new Promise((resolve, reject) => {
      const idPartner = partnerId || getters.getOfferField('partnerId');
      campaign.componentsByPartnerId(id, idPartner).then(
        resp => {
          commit(OFFER_COMPONENTS_BY_PARTNER_ID, resp.data);
          resolve();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_COMPLETED_KO]: ({ state, commit, getters }) =>
    new Promise((resolve, reject) => {
      if (!getters.hasOffer) resolve('404');
      campaign.errorKOByGUID(state.guidURL || lsGetOfferGuid()).then(
        resp => {
          if (resp && resp.data) {
            commit(OFFER_UPDATE_COMPLETED_KO, resp.data);
            resolve();
          } else reject();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    }),

  [OFFER_OPERATION_STEPBACK]: ({ commit }) =>
    new Promise((resolve, reject) => {
      const guid = lsGetOfferGuid();
      campaign.operationsStepback({ id: guid }).then(
        resp => {
          const { idStatus, desStatus, url } = resp.data;
          if (OFFER_STATUS.OK === idStatus) {
            const cookieToPage = OFFER_COOKIE_TO_PAGE[desStatus.toString().toLowerCase()];
            commit(OFFER_SET_CURRENT_STEP, cookieToPage.step);
            resolve({ routerName: cookieToPage.routerName, url });
          } else reject();
        },
        err => {
          commit('ERROR_OCCURRED', err, { root: true });
          reject();
        }
      );
    })
};
